import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonConstants } from '../../constant';

@Component({
  selector: 'iq-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.scss'],
})
export class ErrorPageComponent implements OnInit {
  public footerText = CommonConstants.FooterText;

  constructor(private readonly router: Router) {}

  ngOnInit(): void {}

  navigateHome() {
    this.router.navigate(['/home']);
  }
}
